// src/components/notesdefrais/AjouterNoteDeFraisMobile.js - VERSION CORRIGÉE

import React, { useState, useRef, useEffect } from 'react';
import imageCompression from 'browser-image-compression';
import noteDeFraisStorage from '../../services/noteDeFraisStorage';
import ocrService from '../../services/ocrService';
import cloneManager from '../../services/cloneManager';  // ✅ AJOUTÉ
import apiService from '../../services/apiService';

const CATEGORIES = [
  { value: 'repas', label: '🍽️ Repas', icon: '🍽️' },
  { value: 'deplacement_vehicule', label: '🚗 Déplacement véhicule', icon: '🚗' },
  { value: 'peage', label: '🛣️ Péage', icon: '🛣️' },
  { value: 'hotel', label: '🏨 Hôtel', icon: '🏨' },
  { value: 'transport_public', label: '🚆 Transport public', icon: '🚆' },
  { value: 'parking', label: '🅿️ Parking', icon: '🅿️' },
  { value: 'fournitures', label: '📦 Fournitures', icon: '📦' },
  { value: 'divers', label: '📋 Divers', icon: '📋' }
];

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #d1fae5, #a7f3d0)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #10b981, #059669)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  content: {
    padding: '20px'
  },
  card: {
    background: 'white',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
  },
  cardTitle: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#065f46',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  formGroup: {
    marginBottom: '16px'
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#374151',
    marginBottom: '6px'
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '16px',
    border: '2px solid #e5e7eb',
    borderRadius: '12px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box'
  },
  textarea: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '16px',
    border: '2px solid #e5e7eb',
    borderRadius: '12px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box',
    minHeight: '100px',
    resize: 'vertical'
  },
  select: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '16px',
    border: '2px solid #e5e7eb',
    borderRadius: '12px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box'
  },
  photoSection: {
    marginTop: '20px'
  },
  photoButtons: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: '12px',
    marginBottom: '16px'
  },
  photoBtn: {
    padding: '16px',
    border: '2px dashed #10b981',
    borderRadius: '12px',
    background: '#ecfdf5',
    color: '#065f46',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px'
  },
  photoPreview: {
    position: 'relative',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '2px solid #10b981'
  },
  photoImage: {
    width: '100%',
    height: 'auto',
    display: 'block'
  },
  deletePhotoBtn: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    background: '#ef4444',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    fontSize: '18px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  ocrLoading: {
    padding: '16px',
    background: '#fef3c7',
    border: '2px solid #f59e0b',
    borderRadius: '12px',
    textAlign: 'center',
    marginBottom: '16px'
  },
  ocrSuccess: {
    padding: '16px',
    background: '#d1fae5',
    border: '2px solid #10b981',
    borderRadius: '12px',
    marginBottom: '16px'
  },
  saveButton: {
    position: 'fixed',
    bottom: '20px',
    left: '20px',
    right: '20px',
    padding: '16px',
    background: 'linear-gradient(135deg, #10b981, #059669)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer',
    boxShadow: '0 4px 16px rgba(16, 185, 129, 0.3)'
  }
};

function AjouterNoteDeFraisMobile({ onBack, onSave, onNavigate }) {
  const [formData, setFormData] = useState({
    date_depense: new Date().toISOString().split('T')[0],
    categorie: '',
    description: '',
    montant: '',
    tva: '',
    taux_tva: null,
    trajet: '',
    client_visite: ''
  });
  const [photo, setPhoto] = useState(null); // objectURL pour la prévisualisation
  const [ticketUrl, setTicketUrl] = useState(null); // URL serveur du justificatif uploadé
  const [isProcessing, setIsProcessing] = useState(false);
  const [ocrResult, setOcrResult] = useState(null);
  const [saving, setSaving] = useState(false);
  // Réglage entreprise ("unipersonnel" = auto-validation, "multi_employes" = soumission
  // pour validation par un admin) — mêmes valeurs que côté web (Parametres.jsx).
  const [modeGestionFrais, setModeGestionFrais] = useState('unipersonnel');
  const fileInputRef = useRef(null);
  const photoObjectUrlRef = useRef(null); // Garder trace pour libérer la mémoire

  // Libérer l'objectURL quand le composant est démonté ou qu'une nouvelle photo est prise
  useEffect(() => {
    return () => {
      if (photoObjectUrlRef.current) {
        URL.revokeObjectURL(photoObjectUrlRef.current);
      }
    };
  }, []);

  // Récupère le mode de gestion des frais de l'entreprise pour déterminer le statut
  // initial de la note (comme le fait déjà la saisie web).
  useEffect(() => {
    (async () => {
      try {
        const res = await apiService.getParametres();
        const mode = res?.success ? (res.parametres?.[0]?.mode_gestion_frais || 'unipersonnel') : 'unipersonnel';
        setModeGestionFrais(mode);
      } catch (e) {
        console.warn('⚠️ Impossible de récupérer le mode de gestion des frais, valeur par défaut conservée:', e);
      }
    })();
  }, []);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  /**
   * Calcule les dimensions cibles en conservant le ratio, sans dépasser maxPx sur le plus grand côté.
   */
  const getScaledDimensions = (srcWidth, srcHeight, maxPx) => {
    if (srcWidth <= maxPx && srcHeight <= maxPx) {
      return { width: srcWidth, height: srcHeight };
    }
    if (srcWidth >= srcHeight) {
      return { width: maxPx, height: Math.max(1, Math.round((srcHeight * maxPx) / srcWidth)) };
    }
    return { width: Math.max(1, Math.round((srcWidth * maxPx) / srcHeight)), height: maxPx };
  };

  /**
   * Compresse une image via createImageBitmap avec décodage direct à taille réduite.
   * Contrairement à `new Image()` + canvas, le navigateur n'a jamais besoin de matérialiser
   * la photo en pleine résolution (souvent 12 à 100+ Mpx sur un smartphone récent) en mémoire :
   * c'est ce décodage pleine résolution qui provoque les erreurs "mémoire pleine" sur les
   * appareils avec peu de RAM disponible. On fait d'abord une "sonde" à très basse résolution
   * (quasi gratuite en mémoire) pour connaître le ratio largeur/hauteur réel, puis un seul
   * décodage final directement à la taille cible.
   */
  const compressImageViaBitmap = async (file, maxPx, quality) => {
    const probe = await createImageBitmap(file, {
      resizeWidth: 64,
      resizeQuality: 'low',
      imageOrientation: 'from-image',
    });
    const probeWidth = probe.width || 64;
    const probeHeight = probe.height || 64;
    probe.close();

    // ⚠️ La sonde est TOUJOURS redimensionnée à ~64px par `resizeWidth: 64` : ses dimensions
    // ne donnent donc que le RATIO largeur/hauteur réel de la photo, jamais sa taille absolue.
    // On ne doit surtout pas les passer à `getScaledDimensions` comme si c'était les dimensions
    // sources (cela produisait des images finales d'environ 64px, illisibles pour l'OCR).
    // On calcule donc directement la taille cible en imposant maxPx sur le plus grand côté.
    const ratio = probeWidth / probeHeight;
    const width = ratio >= 1 ? maxPx : Math.max(1, Math.round(maxPx * ratio));
    const height = ratio >= 1 ? Math.max(1, Math.round(maxPx / ratio)) : maxPx;

    const bitmap = await createImageBitmap(file, {
      resizeWidth: width,
      resizeHeight: height,
      resizeQuality: 'medium',
      imageOrientation: 'from-image',
    });

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(bitmap, 0, 0, width, height);
    bitmap.close();

    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          canvas.width = 0;
          canvas.height = 0;
          if (blob) resolve(blob);
          else reject(new Error('Compression échouée'));
        },
        'image/jpeg',
        quality
      );
    });
  };

  /**
   * Méthode historique (fallback) : décode la photo en pleine résolution avant de la réduire.
   * Plus gourmande en mémoire que `compressImageViaBitmap`, utilisée uniquement si
   * `createImageBitmap` avec options de redimensionnement n'est pas disponible ou échoue.
   */
  const compressImageViaCanvasImage = (file, maxPx, quality) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.onload = () => {
        URL.revokeObjectURL(objectUrl); // Libérer immédiatement
        const { width, height } = getScaledDimensions(img.width, img.height, maxPx);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => {
            canvas.width = 0; // Libérer le canvas
            canvas.height = 0;
            if (blob) resolve(blob);
            else reject(new Error('Compression échouée'));
          },
          'image/jpeg',
          quality
        );
      };
      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('Chargement image échoué'));
      };
      img.src = objectUrl;
    });
  };

  /**
   * Compresse une image côté client avant upload/OCR pour éviter les OOM.
   *
   * Utilise `browser-image-compression`, une librairie éprouvée qui gère spécifiquement les
   * nombreux bugs mémoire de Safari/WebKit (iPhone, iPad) : limite de taille de canvas dépassée,
   * images noires/blanches sur les grandes photos, orientation EXIF incorrecte, etc.
   * `createImageBitmap({ resizeWidth, resizeHeight })` — utilisé dans une précédente version —
   * est en effet documenté comme bogué sur WebKit (https://bugs.webkit.org/show_bug.cgi?id=202458),
   * ce qui provoquait encore des plantages mémoire sur certains appareils.
   *
   * `useWebWorker` est désactivé volontairement : par défaut cette librairie charge son script de
   * Worker depuis un CDN, ce qui casserait la prise de photo hors-ligne (l'app doit fonctionner
   * sans réseau, cf. synchronisation manuelle des notes de frais).
   *
   * @param {File} file - fichier original (peut être 10-20 Mo, voire plus sur les smartphones récents)
   * @param {number} maxPx - dimension max (largeur ou hauteur)
   * @param {number} quality - qualité JPEG 0-1
   * @returns {Promise<Blob>} blob compressé (typiquement < 500 Ko)
   */
  const compressImage = async (file, maxPx = 1600, quality = 0.8) => {
    try {
      return await imageCompression(file, {
        maxWidthOrHeight: maxPx,
        maxSizeMB: 1.5,
        initialQuality: quality,
        useWebWorker: false,
        fileType: 'image/jpeg',
        alwaysKeepResolution: false,
      });
    } catch (err) {
      console.warn('⚠️ Compression via browser-image-compression échouée, passage aux solutions de repli:', err);
    }

    // Solutions de repli (méthodes maison), au cas où la librairie échouerait de façon imprévue.
    const supportsResizedBitmap = typeof window !== 'undefined' && 'createImageBitmap' in window;
    const attempts = [];
    if (supportsResizedBitmap) {
      attempts.push(() => compressImageViaBitmap(file, maxPx, quality));
    }
    attempts.push(() => compressImageViaCanvasImage(file, maxPx, quality));
    if (supportsResizedBitmap) {
      attempts.push(() => compressImageViaBitmap(file, Math.round(maxPx * 0.5), Math.max(0.5, quality - 0.2)));
    }

    let lastError = null;
    for (const attempt of attempts) {
      try {
        return await attempt();
      } catch (err) {
        lastError = err;
        console.warn('⚠️ Tentative de compression échouée, passage au repli suivant:', err);
      }
    }
    throw lastError || new Error('Compression échouée');
  };

  const handlePhotoCapture = (useCamera = true) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    
    if (useCamera) {
      input.capture = 'environment';
    }
    
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      try {
        // Compresser avant tout traitement (évite les OOM sur mobile)
        const compressed = await compressImage(file);

        // Prévisualisation légère via objectURL (pas de base64 en mémoire)
        if (photoObjectUrlRef.current) URL.revokeObjectURL(photoObjectUrlRef.current);
        const previewUrl = URL.createObjectURL(compressed);
        photoObjectUrlRef.current = previewUrl;
        setPhoto(previewUrl);
        setTicketUrl(null); // Réinitialiser l'URL précédente

        // Lancer l'OCR avec le blob compressé directement
        await processOCR(compressed);
      } catch (err) {
        console.error('❌ Erreur compression image:', err);
        alert(
          "Impossible de traiter la photo (mémoire insuffisante sur l'appareil).\n\n" +
          "Essayez de :\n" +
          "• Fermer les autres applications ouvertes\n" +
          "• Redémarrer l'application\n" +
          "• Choisir une photo depuis la galerie plutôt qu'avec l'appareil photo\n" +
          "• Réduire la résolution photo dans les réglages de l'appareil"
        );
      }
    };

    input.click();
  };

  const processOCR = async (fileOrBlob) => {
    setIsProcessing(true);
    setOcrResult(null);
    
    try {
      console.log('🔍 Analyse OCR du ticket...');
      const result = await ocrService.extractTicketData(fileOrBlob);
      
      if (result.success) {
        console.log('✅ OCR réussi:', result.data);
        setOcrResult(result.data);
        // Mémoriser l'URL du justificatif déjà uploadé (pas besoin de re-uploader au save)
        if (result.file_url) setTicketUrl(result.file_url);

        // Pré-remplir le formulaire (montant en chaîne pour les <input type="number"> sur mobile)
        setFormData(prev => ({
          ...prev,
          montant:
            result.data.montant != null && result.data.montant !== ''
              ? String(result.data.montant)
              : prev.montant,
          tva: result.data.tva != null ? String(result.data.tva) : prev.tva,
          taux_tva: result.data.taux_tva != null ? result.data.taux_tva : prev.taux_tva,
          date_depense: result.data.date || prev.date_depense,
          categorie: result.data.categorie != null && result.data.categorie !== ''
            ? result.data.categorie
            : prev.categorie,
          description: result.data.marchand ? result.data.marchand : prev.description
        }));
      } else {
        console.warn('⚠️ OCR échoué:', result.error);
        alert('⚠️ Impossible d\'extraire les données automatiquement.\nVous pouvez saisir manuellement.');
      }
    } catch (error) {
      console.error('❌ Erreur OCR:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleDeletePhoto = () => {
    if (window.confirm('Supprimer la photo ?')) {
      setPhoto(null);
      setOcrResult(null);
    }
  };

  const handleSave = async () => {
    // Validation
    if (!formData.categorie) {
      alert('⚠️ Veuillez sélectionner une catégorie');
      return;
    }
    if (!formData.montant || formData.montant <= 0) {
      alert('⚠️ Veuillez saisir un montant valide');
      return;
    }
    if (!formData.description) {
      alert('⚠️ Veuillez saisir une description');
      return;
    }

    setSaving(true);
    try {
      console.log('🔍 ========================================');
      console.log('🔍 SAUVEGARDE NOTE DE FRAIS');
      console.log('🔍 ========================================');
      
      // ✅ CORRECTION : Utiliser cloneManager
      const clone = cloneManager.getClone();
      const inspecteurId = clone?.inspecteur?.id || 'unknown';
      const inspecteurNom = clone?.inspecteur 
        ? `${clone.inspecteur.prenom} ${clone.inspecteur.nom}` 
        : 'Inspecteur';
      
      console.log('🔍 Inspecteur ID:', inspecteurId);
      console.log('🔍 Inspecteur Nom:', inspecteurNom);
      console.log('🔍 Clone:', clone);
      
      // Calculer le mois comptable
      const dateDepense = new Date(formData.date_depense);
      const moisComptable = `${dateDepense.getFullYear()}-${String(dateDepense.getMonth() + 1).padStart(2, '0')}`;

      const montantVal = parseFloat(formData.montant);
      const tvaVal = formData.tva !== '' && formData.tva != null ? parseFloat(formData.tva) : null;
      const tauxTvaVal = formData.taux_tva != null ? Number(formData.taux_tva) : null;

      const noteData = {
        inspecteur_id: inspecteurId,
        inspecteur_nom: inspecteurNom,
        date_depense: formData.date_depense,
        categorie: formData.categorie,
        description: formData.description,
        montant: montantVal,
        tva: tvaVal,
        taux_tva: tauxTvaVal,
        mois_comptable: moisComptable,
        trajet: formData.trajet || null,
        client_visite: formData.client_visite || null,
        justificatif: ticketUrl || null, // URL serveur (pas de base64 en mémoire)
        // "unipersonnel" -> auto-validée ; "multi_employes" -> soumise pour validation par un
        // admin (sinon elle resterait en "brouillon" et n'apparaîtrait jamais dans la file
        // de validation, même une fois synchronisée).
        statut: modeGestionFrais === 'unipersonnel' ? 'validee' : 'soumise',
        synced: false
      };

      console.log('💾 Données note:', noteData);

      await noteDeFraisStorage.saveNote(noteData);
      
      console.log('✅ Note de frais sauvegardée');
      alert('✅ Note de frais ajoutée !');
      
      if (onSave) onSave();
    } catch (error) {
      console.error('❌ ========================================');
      console.error('❌ ERREUR SAUVEGARDE NOTE');
      console.error('❌ ========================================');
      console.error('❌ Erreur:', error);
      console.error('❌ Message:', error.message);
      alert('❌ Erreur lors de la sauvegarde: ' + error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>➕ Nouvelle note</h1>
        <div style={{ width: '70px' }}></div>
      </div>

      <div style={styles.content}>
        {/* Section photo */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>
            📸 Photo du ticket
          </h3>

          {isProcessing && (
            <div style={styles.ocrLoading}>
              <div style={{ width: '30px', height: '30px', border: '4px solid #f59e0b', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 12px' }}></div>
              <p style={{ fontSize: '14px', fontWeight: '600', color: '#92400e', margin: 0 }}>
                🤖 Analyse automatique en cours...
              </p>
              <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            </div>
          )}

          {ocrResult && (
            <div style={styles.ocrSuccess}>
              <p style={{ fontSize: '14px', fontWeight: '600', color: '#065f46', marginBottom: '8px' }}>
                ✅ Données extraites automatiquement :
              </p>
              <ul style={{ fontSize: '13px', color: '#047857', margin: 0, paddingLeft: '20px' }}>
                {ocrResult.montant && <li>Montant TTC : {ocrResult.montant}€</li>}
                {ocrResult.tva != null && <li>TVA : {ocrResult.tva}€{ocrResult.taux_tva ? ` (${ocrResult.taux_tva}%)` : ''}</li>}
                {ocrResult.date && <li>Date : {new Date(ocrResult.date).toLocaleDateString('fr-FR')}</li>}
                {ocrResult.marchand && <li>Marchand : {ocrResult.marchand}</li>}
                {ocrResult.categorie && <li>Catégorie : {CATEGORIES.find(c => c.value === ocrResult.categorie)?.label}</li>}
              </ul>
              <p style={{ fontSize: '12px', color: '#065f46', marginTop: '8px', marginBottom: 0 }}>
                💡 Vérifiez et corrigez si nécessaire
              </p>
            </div>
          )}

          {!photo ? (
            <div style={styles.photoButtons}>
              <button style={styles.photoBtn} onClick={() => handlePhotoCapture(true)}>
                <span style={{ fontSize: '32px' }}>📷</span>
                <span>Prendre une photo</span>
              </button>
              <button style={styles.photoBtn} onClick={() => handlePhotoCapture(false)}>
                <span style={{ fontSize: '32px' }}>🖼️</span>
                <span>Galerie</span>
              </button>
              <button
                style={styles.photoBtn} 
                onClick={() => {
                  console.log('🚗 Clic calculateur, onNavigate:', onNavigate);
                  if (onNavigate) onNavigate('calculateur');
                }}
              >
                <span style={{ fontSize: '32px' }}>🚗</span>
                <span>Calculateur km</span>
              </button>
            </div>
          ) : (
            <div style={styles.photoPreview}>
              <img src={photo} style={styles.photoImage} alt="Ticket" />
              <button style={styles.deletePhotoBtn} onClick={handleDeletePhoto}>
                ✕
              </button>
            </div>
          )}
        </div>

        {/* Formulaire */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>
            📝 Informations
          </h3>

          <div style={styles.formGroup}>
            <label style={styles.label}>Date *</label>
            <input
              type="date"
              style={styles.input}
              value={formData.date_depense}
              onChange={(e) => handleChange('date_depense', e.target.value)}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Catégorie *</label>
            <select
              style={styles.select}
              value={formData.categorie}
              onChange={(e) => handleChange('categorie', e.target.value)}
            >
              <option value="">Sélectionner...</option>
              {CATEGORIES.map(cat => (
                <option key={cat.value} value={cat.value}>{cat.label}</option>
              ))}
            </select>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Montant (€) *</label>
            <input
              type="number"
              step="0.01"
              style={styles.input}
              value={formData.montant}
              onChange={(e) => handleChange('montant', e.target.value)}
              placeholder="24.50"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Description *</label>
            <input
              type="text"
              style={styles.input}
              value={formData.description}
              onChange={(e) => handleChange('description', e.target.value)}
              placeholder="Ex: Déjeuner client, Carburant..."
            />
          </div>

          {/* Champs optionnels */}
          {(formData.categorie === 'deplacement_vehicule' || formData.categorie === 'peage') && (
            <div style={styles.formGroup}>
              <label style={styles.label}>Trajet (optionnel)</label>
              <input
                type="text"
                style={styles.input}
                value={formData.trajet}
                onChange={(e) => handleChange('trajet', e.target.value)}
                placeholder="Ex: Lyon → Paris"
              />
            </div>
          )}

          {formData.categorie === 'repas' && (
            <div style={styles.formGroup}>
              <label style={styles.label}>Client visité (optionnel)</label>
              <input
                type="text"
                style={styles.input}
                value={formData.client_visite}
                onChange={(e) => handleChange('client_visite', e.target.value)}
                placeholder="Nom du client"
              />
            </div>
          )}
        </div>
      </div>

      {/* Bouton sauvegarder */}
      <button 
        style={{ 
          ...styles.saveButton, 
          ...(saving ? { opacity: 0.6, cursor: 'not-allowed' } : {}) 
        }} 
        onClick={handleSave}
        disabled={saving}
      >
        {saving ? '⏳ Enregistrement...' : '💾 Enregistrer'}
      </button>
    </div>
  );
}

export default AjouterNoteDeFraisMobile;